























import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { displayRoboAutorizacao } from '@/utils/common'

@Component
export default class ComponentBackofficeRetornoOperadora extends Vue {
  formatStatus(status: string) {
    return displayRoboAutorizacao(status)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get enabled() {
    return !['', null, undefined].includes(this.getBackofficeGlobalStore.solicitacao.roboAutorizacaoStatusDaAutorizacao)
  }

  get status() {
    return this.getBackofficeGlobalStore.solicitacao.roboAutorizacaoStatusDaAutorizacao
  }

  get negativa() {
    const resposta = this.getBackofficeGlobalStore.solicitacao.roboAutorizacaoMotivoNegativa!
    if (resposta!.startsWith('[')) {
      return { type: 'lista', content: JSON.parse(resposta) }
    }
    return { type: 'texto', content: resposta }
  }
}
